import { Lightbulb, Loader2 } from "lucide-react";
import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import Button from "../ui/Button";
import Card from "../ui/Card";

interface FormData {
  idea: string;
  context: string;
  goals: string;
}

const BrainstormingSection: React.FC = () => {
  const { t, isRTL } = useApp();
  const [formData, setFormData] = useState<FormData>({
    idea: "",
    context: "",
    goals: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setIsSubmitting(false);
  };

  const isFormValid = formData.idea && formData.context && formData.goals;

  return (
    <section
      className="py-16 bg-white dark:bg-neutral-900"
      aria-labelledby="brainstorming-heading"
    >
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <h2
            id="brainstorming-heading"
            className={`text-3xl md:text-4xl font-bold text-neutral-900 dark:text-white mb-4 ${
              isRTL ? "font-arabic" : "font-english"
            }`}
          >
            {t("step1Title")}
          </h2>
        </div>

        <Card className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                id="business-idea"
                value={formData.idea}
                onChange={(e) => setFormData({ ...formData, idea: e.target.value })}
                placeholder={isRTL ? "فكرة العمل" : "Business Idea"}
                className={`w-full px-4 py-3 border rounded-lg focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 ${
                  isRTL ? "font-arabic text-right" : "font-english text-left"
                }`}
                data-testid="business-idea-input"
              />
            </div>

            <div>
              <input
                id="target-market"
                value={formData.context}
                onChange={(e) => setFormData({ ...formData, context: e.target.value })}
                placeholder={isRTL ? "السوق المستهدف" : "Target Market"}
                className={`w-full px-4 py-3 border rounded-lg focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200 ${
                  isRTL ? "font-arabic text-right" : "font-english text-left"
                }`}
                data-testid="target-market-input"
              />
            </div>

            <div className="flex justify-center pt-4">
              <Button
                type="submit"
                size="lg"
                disabled={!isFormValid || isSubmitting}
                className="px-12 py-4 bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700"
                data-testid="brainstorm-submit"
              >
                {isSubmitting ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin mr-2" />
                    {isRTL ? "جاري المعالجة..." : "Processing..."}
                  </>
                ) : (
                  <>
                    <Lightbulb className="w-5 h-5 mr-2" />
                    {isRTL ? "ابدأ العصف الذهني" : "Start Brainstorming"}
                  </>
                )}
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </section>
  );
};

export default BrainstormingSection;
